__turbopack_context__.v({
  "carousel": "carousel-module-scss-module__zXfh1W__carousel",
  "dot": "carousel-module-scss-module__zXfh1W__dot",
  "dotActive": "carousel-module-scss-module__zXfh1W__dotActive",
  "dots": "carousel-module-scss-module__zXfh1W__dots",
  "frame": "carousel-module-scss-module__zXfh1W__frame",
  "navButton": "carousel-module-scss-module__zXfh1W__navButton",
  "slide": "carousel-module-scss-module__zXfh1W__slide",
  "slideContent": "carousel-module-scss-module__zXfh1W__slideContent",
  "slides": "carousel-module-scss-module__zXfh1W__slides",
  "viewport": "carousel-module-scss-module__zXfh1W__viewport",
});
